import LocalStorage from '@web/common/LocalStorage'

const CONTINUE_TRAINING_KEY_PREFIX = 'acProject_continue_training'
const LEGACY_CONTINUE_TRAINING_KEY = CONTINUE_TRAINING_KEY_PREFIX

export function getContinueTrainingKey (userId: number | undefined | null): string | null {
  if (!userId) {
    return null
  }
  return `${CONTINUE_TRAINING_KEY_PREFIX}_${userId}`
}

export function migrateLegacyContinueTrainingKey (userId: number | undefined | null): void {
  const legacy = LocalStorage.get(LEGACY_CONTINUE_TRAINING_KEY)
  if (!legacy) return

  const userKey = getContinueTrainingKey(userId)
  if (userKey && !LocalStorage.get(userKey)) {
    LocalStorage.set(userKey, legacy)
  }

  LocalStorage.remove(LEGACY_CONTINUE_TRAINING_KEY)
}
